module.exports = "<div class=\"container\">\r\n  <h1>\r\n    {{title}}\r\n  </h1>\r\n  <button (click)=\"notify()\">Show Notification</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/notification-components/push-notification/push-notification.component.html
// module id = ./src/app/notification-components/push-notification/push-notification.component.html
// module chunks = main